<template>
  <div class="hello">
        <div class="carousel-wrap height">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-5" style="position: relative;">
              <img src="../assets/未标题-888.png" class="left-img" alt="">
          </div>
          <div class="carousel-text col-xs-12 col-sm-12 col-md-12 col-lg-5">
            <p>全国专业化、效率化、系统化酒店外包</p>
            <p>人力资源服务平台，值得你们的信赖！</p>
            <ul class="carousel-text-ul">
              <li>微心帮是酒店及劳务输出企业人力资源整合平台，各类星级酒店、 连锁酒店、民宿、家政及劳务输出企业首选。 </li>
              <li>微心帮以服务人员和企业为核心，助力服务人员和企业发展，提 供信息资源、培训课程、管理经营、运营制度、考核体系、企业 对账等多种服务项目</li>
              <li>微心帮以提升酒店人力服务品质，推动行业服务能力提升为价值， 资源共享，通过能力输出，降低社会整体的服务成本。</li>
            </ul>
            <div class="carousel-text-ul-wrap">
              <img class="carousel-text-ul-QR" src="../assets/1571208580.png" alt="">
              <div class="carousel-text-ul-text">APP下载</div>
            </div>
            <div class="carousel-text-ul-wrap" @click="toHotel()">
              <img class="carousel-text-ul-QR"  style="cursor: pointer" src="../assets/untitled-20.png" alt="">
              <div class="carousel-text-ul-text"><span  style="cursor: pointer">酒店</span></div>
            </div>
            <div class="carousel-text-ul-wrap" @click="toKeeperauth()">
              <img class="carousel-text-ul-QR"  style="cursor: pointer" src="../assets/untitled-21.png" alt="">
              <div class="carousel-text-ul-text"><span  style="cursor: pointer">人力服务公司</span></div>
            </div>
           <!-- <div @click="toHotel()">
              <img src="../assets/untitled-20.png" alt="">
              <p>酒店</p>
            </div>
            <div @click="toKeeperauth()">
              <img src="../assets/untitled-21.png" alt="">
              <p>人力服务公司</p>
            </div>-->
          </div>
        </div>
  </div>
</template>

<script>
    export default {
        name: 'Home',
        data() {
            return {
                height: 0,
                cooperateList: [
                    {cooperateUrl: require('../assets/hotel1.png')},
                    {cooperateUrl: require('../assets/hotel2.png')},
                    {cooperateUrl: require('../assets/hotel3.png')},
                    {cooperateUrl: require('../assets/logo.png')}
                ]
            }
        },
        mounted () {
          this.height = window.innerHeight - 60;
        },
      methods:{
        toHotel(){
          // this.$router.push({ path:'http://hk.finewe.com.cn/#/hotelauth'});
          window.location.href = 'https://admin.weixinbang.com.cn/#/hotelauth';
        },
        toKeeperauth(){
          window.location.href = 'https://admin.weixinbang.com.cn/#/keeperauth';
        },
      }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '../assets/scss/index.scss';
@media screen and (min-width:0px) and (max-width:400px){
    // body {background-color:#f5f5f5;}
    .height{
      height: 700px;
    }
  }
  @media screen and (min-width:400px) and (max-width:900px){
    // body {background-color:#f5f5f5;}
    .height{
      height: 880px;
    }
  }
  @media screen and (min-width:900px) and (max-width:1200px){
    // body {background-color:#f5f5f5;}
    .height{
      height: 1200px;
    }
  }
  @media screen and (min-width:600px) and (max-width:900px){
    // body {background-color:#f5f5f5;}
    .height{
      height: 1050px;
    }
  }
  @media screen and (min-width: 1200px) {
    .height{
      height: calc(100vh - 60px);
      /*height: calc(100vh - 60px);*/
    }
  }
  // @media screen and (max-width: 768px) {
  //     .height{
  //       height: 730px;
  //     }
  // }
  .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    /*line-height: 400px;*/
    margin: 0;
  }

  @media screen and (max-width: 768px) {
      .carousel-wrap{
        // height: 730px;
        background: url('../assets/banner-1.png')no-repeat;
        background-size: 100% 100%;
        // display: flex;
        // justify-content: center;
        // align-items: center;
      }
    .carousel-text {
      margin-top:10px;
      // @include px2rem(width, 600);
      @include px2rem(height, 700);
      // @include px2rem(margin-left, 150);
      @include flex(center);
      p{
        display: block;
        width: 100%;
        // font-size: 20px;
        @include px2rem(font-size, 30);
        font-weight: 600;
        color: #ffdd11;
        line-height: 24px;
      }
    }
    .carousel-text-ul{
      // width: 500px;
      // @include px2rem(width, 500);
      width: 70%;
      li{
        display: block;
        // @include px2rem(width, 500);
        width: 100%;

        @include px2rem(font-size, 18);
        // width: 500px;
        text-align: left;
        color:#fff;
        padding: 4px;
        border: 1px dotted #fff;
        border-radius: 5px;
        margin-top: 20px;
        box-sizing: border-box;
        // i{
        //   border-radius: 50%;
        //   background: #fff;
        //   display: block;
        //   width: 10px;
        //   height: 10px;
        //   float: left;
        // }
      }
    }
    .carousel-text-ul-wrap{
      // padding: 20px;
      width: 33.3%;
      @include px2rem(padding, 20);
      .carousel-text-ul-QR{
        @include px2rem(width, 100);
        @include px2rem(height, 100);
      }
      .carousel-text-ul-text{
        color: #fff;
        @include px2rem(font-size, 24);
      }
    }
    .left-img{
      width: 70%;
      margin-top: 20px;
    }
  }
  @media(min-width: 768px) and (max-width: 992px) {
    .carousel-wrap{
      // height: 730px;
      background: url('../assets/banner-1.png')no-repeat;
      background-size: 100% 100%;
      // display: flex;
      // justify-content: center;
      // align-items: center;
    }
    .carousel-text {
      margin-top:10px;
      // @include px2rem(width, 600);
      @include px2rem(height, 700);
      // @include px2rem(margin-left, 150);
      @include flex(center);
      p{
        display: block;
        width: 100%;
        // font-size: 20px;
        @include px2rem(font-size, 30);
        font-weight: 600;
        color: #ffdd11;
        line-height: 24px;
      }
    }
    .carousel-text-ul{
      // width: 500px;
      // @include px2rem(width, 500);
      width: 70%;
      li{
        display: block;
        // @include px2rem(width, 500);
        width: 100%;

        @include px2rem(font-size, 18);
        // width: 500px;
        text-align: left;
        color:#fff;
        padding: 4px;
        border: 1px dotted #fff;
        border-radius: 5px;
        margin-top: 20px;
        box-sizing: border-box;
        // i{
        //   border-radius: 50%;
        //   background: #fff;
        //   display: block;
        //   width: 10px;
        //   height: 10px;
        //   float: left;
        // }
      }
    }
    .carousel-text-ul-wrap{
      // padding: 20px;
      width: 33.3%;
      @include px2rem(padding, 20);
      .carousel-text-ul-QR{
        @include px2rem(width, 100);
        @include px2rem(height, 100);
      }
      .carousel-text-ul-text{
        color: #fff;
        @include px2rem(font-size, 24);
      }
    }
    .left-img{
      width: 70%;
      margin-top: 20px;
    }
  }
@media(min-width: 992px) and (max-width: 1200px){
  .carousel-wrap{
    // height: 730px;
    background: url('../assets/banner-1.png')no-repeat;
    background-size: 100% 100%;
    // display: flex;
    // justify-content: center;
    // align-items: center;
  }
  .carousel-text {
    margin-top:10px;
    // @include px2rem(width, 600);
    @include px2rem(height, 700);
    // @include px2rem(margin-left, 150);
    @include flex(center);
    p{
      display: block;
      width: 100%;
      // font-size: 20px;
      @include px2rem(font-size, 30);
      font-weight: 600;
      color: #ffdd11;
      line-height: 24px;
    }
  }
  .carousel-text-ul{
    // width: 500px;
    // @include px2rem(width, 500);
    width: 70%;
    li{
      display: block;
      // @include px2rem(width, 500);
      width: 100%;

      @include px2rem(font-size, 18);
      // width: 500px;
      text-align: left;
      color:#fff;
      padding: 4px;
      border: 1px dotted #fff;
      border-radius: 5px;
      margin-top: 20px;
      box-sizing: border-box;
      // i{
      //   border-radius: 50%;
      //   background: #fff;
      //   display: block;
      //   width: 10px;
      //   height: 10px;
      //   float: left;
      // }
    }
  }
  .carousel-text-ul-wrap{
    // padding: 20px;
    width: 33.3%;
    @include px2rem(padding, 20);
    .carousel-text-ul-QR{
      @include px2rem(width, 100);
      @include px2rem(height, 100);
    }
    .carousel-text-ul-text{
      color: #fff;
      @include px2rem(font-size, 24);
    }
  }
  .left-img{
    width: 70%;
    margin-top: 20px;
  }
}
@media screen and (min-width: 1200px) {
  .carousel-wrap{
    /*height: calc(100vh - 60px);*/
    // height: 600px;
    width: 100%;
    background: url('../assets/banner-1.png')no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .carousel-text {
    // @include px2rem(width, 600);
    @include px2rem(height, 700);
    // @include px2rem(margin-left, 150);
    @include flex(center);
    p{
      display: block;
      width: 100%;
      // font-size: 20px;
      @include px2rem(font-size, 28);
      font-weight: 600;
      color: #ffdd11;
      line-height: 30px;
    }
  }
  .carousel-text-ul{
    // width: 500px;
    // @include px2rem(width, 500);
    width: 100%;
    li{
      display: block;
      // @include px2rem(width, 500);
      width: 100%;

      @include px2rem(font-size, 22);
      // width: 500px;
      text-align: left;
      color:#fff;
      padding: 10px 10px;
      border: 1px dotted #fff;
      border-radius: 5px;
      margin-top: 20px;
      box-sizing: border-box;
      // i{
      //   border-radius: 50%;
      //   background: #fff;
      //   display: block;
      //   width: 10px;
      //   height: 10px;
      //   float: left;
      // }
    }
  }
  .carousel-text-ul-wrap{
    // padding: 20px;
    width: 33.3%;
    @include px2rem(padding, 20);
    .carousel-text-ul-QR{
      @include px2rem(width, 120);
      @include px2rem(height, 120);
    }
    .carousel-text-ul-text{
      color: #fff;
      @include px2rem(font-size, 24);
    }
  }
  .left-img{
    width: 100%;
  }
}
  .carousel-wrap {

  }

  .carousel-cooperate-list > img {
    width: 25%;
    height: 120px;
    margin: 10px 20px;
  }

  .carousel-graphic {
    width: 35%;
    height: 400px;
    float: left;
    margin-left: 50px;
  }


  .carousel-text > h1 {
    line-height: 50px;
  }

  .carousel-code {
    width: 100%;
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    justify-items: center;
    flex-wrap: wrap;
    justify-content: center;
  }

  .carousel-code img {
    @include px2rem(width, 150);
    @include px2rem(height, 150);

    // width: 150px;
    // height: 150px;
  }

  .carousel-cooperate > h2 {
    line-height: 60px;
  }
  .home-banner{
    // position: absolute;
    // @include px2rem(left, 250);
    // @include px2rem(top, 150);
    @include px2rem(width, 700);
    // left: 50px;
    // top: 150px;
    // width: 700px;
    @include flex(space-between)
  }
  .home-banner-hotel{
    @include px2rem(width, 150);
    @include px2rem(height, 100);

    // width: 150px;
    // height: 100px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-items: center;
    flex-wrap: wrap;
    justify-content: center;
    .home-banner-hotel-title{
      @include px2rem(width, 100);
      @include px2rem(height, 30);
      @include px2rem(line-height, 32);
      @include px2rem(font-size, 20);

      // width: 75px;
      // height: 25px;
      // line-height: 25px;
      // font-size: 16px;
      color:#fff;
      border-radius: 5px;
      background: #ff6d1d;
    }
    .home-banner-hotel-list{
      @include px2rem(width, 150);
      @include px2rem(height, 100);
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-items: center;
      flex-wrap: wrap;
      justify-content: space-around;
      span{
        @include px2rem(width, 50);
        @include px2rem(height, 30);
        @include px2rem(line-height, 32);
        @include px2rem(font-size, 20);
        // @include px2rem(line-height, 25);
        display: block;
        float: left;
        color:#fff;
        border: 1px dotted #fff;
        // font-size: 16px;
        border-radius: 5px;
      }
    }
  }
  .home-banner-clear{
    @include px2rem(width, 150);
    @include px2rem(height, 100);
    position: absolute;
    bottom:0;
    @include px2rem(bottom, 100);
    @include px2rem(left, 620);

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-items: center;
    flex-wrap: wrap;
    justify-content: center;
    .home-banner-hotel-title{
      @include px2rem(width, 100);
      @include px2rem(height, 30);
      @include px2rem(line-height, 32);
      @include px2rem(font-size, 20);
      color:#fff;
      border-radius: 5px;
      background: #ff9f41;
    }
    .home-banner-hotel-list{
      @include px2rem(width, 150);
      @include px2rem(height, 100);
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-items: center;
      flex-wrap: wrap;
      justify-content: space-around;
      span{
        @include px2rem(width, 50);
        @include px2rem(height, 30);
        @include px2rem(line-height, 32);
        @include px2rem(font-size, 20);
        display: block;
        float: left;
        color:#fff;
        border: 1px dotted #fff;
        border-radius: 5px;
      }
    }
  }
  .home-banner-img{
    // position: absolute;
    // @include px2rem(width, 500);
    // @include px2rem(left, 350);
    // @include px2rem(top, 250);
    // @include px2rem(width, 500);

    /*width: 30%;*/
    // left: 250px;
    // top: 250px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-items: center;
    flex-wrap: wrap;
    justify-content: center;
    img{
      // @include px2rem(width, 500);
      // @include px2rem(height, 500);
      width: 30%;
      // width: 300px;
      // height: 300px;
    }
    .home-banner-img-content{
        // width: 380px;
        // @include px2rem(width, 380);
        width: 500px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-items: center;
        flex-wrap: wrap;
        justify-content: space-around;
        span{
          display: block;
          @include px2rem(width, 100);
          @include px2rem(height, 30);
          @include px2rem(line-height, 32);
          @include px2rem(font-size, 20);
          @include px2rem(margin-top, 20);
          float: left;
          color:#ff6d1d;
          background: rgba($color: #fff, $alpha: 0.7);
          // font-size: 16px;
          border-radius: 5px;
          // margin-top: 20px;
        }
    }
  }
  .home-banner-img-mark1{
    // @include px2rem(width, 20);
    @include px2rem(width, 80);
    position: absolute;
    @include px2rem(top, 150);
    @include px2rem(left, 30);
  }
  .home-banner-img-mark2{
    // @include px2rem(width, 30);
    @include px2rem(width, 60);
    position: absolute;
    @include px2rem(top, 370);
    @include px2rem(left, 560);
  }
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue